module.exports = __webpack_public_path__ + "media/images/categories/intuitive-442762b6c2c5ac05ba2f92d724558a76.png";